module.exports = __webpack_public_path__ + "static/media/Illus-Winter.7d02fa38.png";